webpackJsonp([114276838955818,60335399758886],{

/***/ 304:
/***/ (function(module, exports) {

	module.exports = {"data":{"meta":{"siteMetadata":{"title":"cloudThing - Develop | DevOps | Dynamics","description":"cloudThing solves complex business problems with Dynamics 365 and Bespoke Software from their offices in Birmingham, UK and Bangalore, India.","keywords":"develop devops dynamics"}}},"layoutContext":{}}

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(616);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(304);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _styles = __webpack_require__(11);
	
	var _exactProp = _interopRequireDefault(__webpack_require__(132));
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0,
	        // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	var CssBaseline =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(CssBaseline, _React$Component);
	
	  function CssBaseline() {
	    (0, _classCallCheck2.default)(this, CssBaseline);
	    return (0, _possibleConstructorReturn2.default)(this, (CssBaseline.__proto__ || Object.getPrototypeOf(CssBaseline)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(CssBaseline, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CssBaseline;
	}(_react.default.Component);
	
	CssBaseline.propTypes =  false ? {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : {};
	CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes, 'CssBaseline') : {};
	CssBaseline.defaultProps = {
	  children: null
	};
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(478));

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _Modal = _interopRequireDefault(__webpack_require__(347));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _Slide = _interopRequireDefault(__webpack_require__(520));
	
	var _Paper = _interopRequireDefault(__webpack_require__(92));
	
	var _helpers = __webpack_require__(80);
	
	var _transitions = __webpack_require__(111);
	
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(props) {
	  return ['left', 'right'].indexOf(props.anchor) !== -1;
	}
	
	function getAnchor(props) {
	  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
	}
	
	var styles = function styles(theme) {
	  return {
	    docked: {
	      flex: '0 0 auto'
	    },
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100vh',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 'none'
	    },
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	    modal: {} // Just here so people can override the style.
	
	  };
	};
	/**
	 * The properties of the [Modal](/api/modal) component are available
	 * when `variant="temporary"` is set.
	 */
	
	
	exports.styles = styles;
	
	var Drawer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Drawer, _React$Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _temp));
	  }
	
	  (0, _createClass2.default)(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    } // Let's assume that the Drawer will always be rendered on user space.
	    // We use that state is order to skip the appear transition during the
	    // initial mount of the component.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          anchorProp = _props.anchor,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          elevation = _props.elevation,
	          _props$ModalProps = _props.ModalProps;
	      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	      var BackdropPropsProp = _props$ModalProps.BackdropProps,
	          ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	          onClose = _props.onClose,
	          open = _props.open,
	          PaperProps = _props.PaperProps,
	          SlideProps = _props.SlideProps,
	          theme = _props.theme,
	          transitionDuration = _props.transitionDuration,
	          variant = _props.variant,
	          other = (0, _objectWithoutProperties2.default)(_props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
	      var anchor = getAnchor(this.props);
	
	      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        elevation: variant === 'temporary' ? elevation : 0,
	        square: true,
	        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
	      }, PaperProps), children);
	
	      if (variant === 'permanent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), drawer);
	      }
	
	      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	        "in": open,
	        direction: oppositeDirection[anchor],
	        timeout: transitionDuration,
	        appear: this.mounted
	      }, SlideProps), drawer);
	
	      if (variant === 'persistent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), slidingDrawer);
	      } // variant === temporary
	
	
	      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	        BackdropProps: (0, _objectSpread2.default)({}, BackdropPropsProp, {
	          transitionDuration: transitionDuration
	        }),
	        className: (0, _classnames.default)(classes.modal, className),
	        open: open,
	        onClose: onClose
	      }, other, ModalProps), slidingDrawer);
	    }
	  }]);
	  return Drawer;
	}(_react.default.Component);
	
	Drawer.propTypes =  false ? {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Properties applied to the `Modal` element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the `Slide` element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant of drawer.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	Drawer.defaultProps = {
	  anchor: 'left',
	  elevation: 16,
	  open: false,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  },
	  variant: 'temporary' // Mobile first.
	
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false,
	  withTheme: true
	})(Drawer);
	
	exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(480));

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(33));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(55));
	
	var _debounce = _interopRequireDefault(__webpack_require__(182));
	
	var _Transition = _interopRequireDefault(__webpack_require__(60));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(163));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(130));
	
	var _transitions = __webpack_require__(111);
	
	var _utils = __webpack_require__(131);
	
	// @inheritedComponent Transition
	var GUTTER = 24; // Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
	  } else if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
	  } else if (direction === 'up') {
	    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	/**
	 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	var Slide =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Slide);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Slide.__proto__ || Object.getPrototypeOf(Slide)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _this.transition = null, _this.handleResize = (0, _debounce.default)(function () {
	      // Skip configuration where the position is screen size invariant.
	      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	        return;
	      }
	
	      var node = _reactDom.default.findDOMNode(_this.transition);
	
	      if (node) {
	        setTranslateValue(_this.props, node);
	      }
	    }, 166), _this.handleEnter = function (node) {
	      setTranslateValue(_this.props, node);
	      (0, _utils.reflow)(node);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleEntering = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.webkitTransform = 'translate(0, 0)';
	      node.style.transform = 'translate(0, 0)';
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      setTranslateValue(_this.props, node);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.handleExited = function (node) {
	      // No need for transitions when the component is hidden
	      node.style.webkitTransition = '';
	      node.style.transition = '';
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _temp));
	  }
	
	  (0, _createClass2.default)(Slide, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	
	      this.mounted = true;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.clear();
	    }
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var node = _reactDom.default.findDOMNode(this.transition);
	
	      if (node) {
	        node.style.visibility = 'inherit';
	        setTranslateValue(this.props, node);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
	      var style = {}; // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	
	      if (!this.props.in && !this.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _objectSpread2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExited: this.handleExited,
	        appear: true,
	        style: style,
	        ref: function ref(node) {
	          _this2.transition = node;
	        }
	      }, other), children));
	    }
	  }]);
	  return Slide;
	}(_react.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Slide.defaultProps = {
	  direction: 'down',
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Slide);
	
	exports.default = _default;

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(519));

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global window */
	
	var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
	
	var isNode = typeof module !== 'undefined' && typeof module.exports !== 'undefined';
	
	exports.isBrowser = isBrowser;
	exports.isNode = isNode;

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {function detect() {
	  var nodeVersion = getNodeVersion();
	  if (nodeVersion) {
	    return nodeVersion;
	  } else if (typeof navigator !== 'undefined') {
	    return parseUserAgent(navigator.userAgent);
	  }
	
	  return null;
	}
	
	function detectOS(userAgentString) {
	  var rules = getOperatingSystemRules();
	  var detected = rules.filter(function (os) {
	    return os.rule && os.rule.test(userAgentString);
	  })[0];
	
	  return detected ? detected.name : null;
	}
	
	function getNodeVersion() {
	  var isNode = typeof navigator === 'undefined' && typeof process !== 'undefined';
	  return isNode ? {
	    name: 'node',
	    version: process.version.slice(1),
	    os: __webpack_require__(1441).type().toLowerCase()
	  } : null;
	}
	
	function parseUserAgent(userAgentString) {
	  var browsers = getBrowserRules();
	  if (!userAgentString) {
	    return null;
	  }
	
	  var detected = browsers.map(function(browser) {
	    var match = browser.rule.exec(userAgentString);
	    var version = match && match[1].split(/[._]/).slice(0,3);
	
	    if (version && version.length < 3) {
	      version = version.concat(version.length == 1 ? [0, 0] : [0]);
	    }
	
	    return match && {
	      name: browser.name,
	      version: version.join('.')
	    };
	  }).filter(Boolean)[0] || null;
	
	  if (detected) {
	    detected.os = detectOS(userAgentString);
	  }
	
	  if (/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(userAgentString)) {
	    detected = detected || {};
	    detected.bot = true;
	  }
	
	  return detected;
	}
	
	function getBrowserRules() {
	  return buildRules([
	    [ 'aol', /AOLShield\/([0-9\._]+)/ ],
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'samsung', /SamsungBrowser\/([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
	    [ 'facebook', /FBAV\/([0-9\.]+)/],
	    [ 'instagram', /Instagram\ ([0-9\.]+)/],
	    [ 'ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/]
	  ]);
	}
	
	function getOperatingSystemRules() {
	  return buildRules([
	    [ 'iOS', /iP(hone|od|ad)/ ],
	    [ 'Android OS', /Android/ ],
	    [ 'BlackBerry OS', /BlackBerry|BB10/ ],
	    [ 'Windows Mobile', /IEMobile/ ],
	    [ 'Amazon OS', /Kindle/ ],
	    [ 'Windows 3.11', /Win16/ ],
	    [ 'Windows 95', /(Windows 95)|(Win95)|(Windows_95)/ ],
	    [ 'Windows 98', /(Windows 98)|(Win98)/ ],
	    [ 'Windows 2000', /(Windows NT 5.0)|(Windows 2000)/ ],
	    [ 'Windows XP', /(Windows NT 5.1)|(Windows XP)/ ],
	    [ 'Windows Server 2003', /(Windows NT 5.2)/ ],
	    [ 'Windows Vista', /(Windows NT 6.0)/ ],
	    [ 'Windows 7', /(Windows NT 6.1)/ ],
	    [ 'Windows 8', /(Windows NT 6.2)/ ],
	    [ 'Windows 8.1', /(Windows NT 6.3)/ ],
	    [ 'Windows 10', /(Windows NT 10.0)/ ],
	    [ 'Windows ME', /Windows ME/ ],
	    [ 'Open BSD', /OpenBSD/ ],
	    [ 'Sun OS', /SunOS/ ],
	    [ 'Linux', /(Linux)|(X11)/ ],
	    [ 'Mac OS', /(Mac_PowerPC)|(Macintosh)/ ],
	    [ 'QNX', /QNX/ ],
	    [ 'BeOS', /BeOS/ ],
	    [ 'OS/2', /OS\/2/ ],
	    [ 'Search Bot', /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/ ]
	  ]);
	}
	
	function buildRules(ruleTuples) {
	  return ruleTuples.map(function(tuple) {
	    return {
	      name: tuple[0],
	      rule: tuple[1]
	    };
	  });
	}
	
	module.exports = {
	  detect: detect,
	  detectOS: detectOS,
	  getNodeVersion: getNodeVersion,
	  parseUserAgent: parseUserAgent
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(154)))

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = baseRest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = omit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Animated = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _browserOrNode = __webpack_require__(666);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isLteIE9 = function isLteIE9() {
	  var ua = _browserOrNode.isBrowser ? window.navigator.userAgent : "";
	  var ie = ua.indexOf("MSIE ");
	  return ie > -1 && parseInt(ua.substring(ie + 5, ua.indexOf(".", ie)), 10) <= 9;
	};
	
	var Animated = exports.Animated = function (_React$Component) {
	  _inherits(Animated, _React$Component);
	
	  function Animated(props) {
	    _classCallCheck(this, Animated);
	
	    var _this = _possibleConstructorReturn(this, (Animated.__proto__ || Object.getPrototypeOf(Animated)).call(this, props));
	
	    _this.state = props.animateOnMount ? {
	      animation: props.isVisible ? props.animationIn : props.animationOut,
	      delay: props.isVisible ? props.animationInDelay : props.animationOutDelay
	    } : {};
	    return _this;
	  }
	
	  _createClass(Animated, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var isVisible = nextProps.isVisible;
	
	      if (isVisible !== this.props.isVisible) {
	        var _props = this.props,
	            animationIn = _props.animationIn,
	            animationOut = _props.animationOut,
	            animationInDelay = _props.animationInDelay,
	            animationOutDelay = _props.animationOutDelay;
	
	        this.setState({
	          animation: isVisible ? animationIn : animationOut,
	          delay: isVisible ? animationInDelay : animationOutDelay
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          style = _props2.style,
	          isVisible = _props2.isVisible,
	          innerRef = _props2.innerRef,
	          className = _props2.className;
	      var _state = this.state,
	          animation = _state.animation,
	          delay = _state.delay;
	
	
	      var classes = (0, _classnames2.default)("animated", animation, className);
	
	      if (isLteIE9() || !animation) {
	        style.opacity = isVisible ? 1 : 0;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: classes,
	          ref: innerRef,
	          style: _extends({
	            animationDelay: delay + "ms",
	            pointerEvents: isVisible ? "all" : "none"
	          }, style)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Animated;
	}(_react2.default.Component);
	
	Animated.propTypes = {
	  animationIn: _propTypes.string,
	  animationOut: _propTypes.string,
	  animationInDelay: _propTypes.number,
	  animationOutDelay: _propTypes.number,
	  style: _propTypes.object,
	  isVisible: _propTypes.bool,
	  innerRef: _propTypes.func,
	  className: _propTypes.string,
	  animateOnMount: _propTypes.bool
	};
	
	Animated.defaultProps = {
	  animationIn: "fadeIn",
	  animationOut: "fadeOut",
	  className: "",
	  animationInDelay: 0,
	  animationOutDelay: 0,
	  isVisible: true,
	  style: {},
	  animateOnMount: true
	};

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var omit = __webpack_require__(149);
	var cx = __webpack_require__(5);
	var styleUtils = __webpack_require__(332);
	exports.propTypes = {
	    message: PropTypes.string,
	    onAccept: PropTypes.func.isRequired,
	    link: PropTypes.element,
	    buttonMessage: PropTypes.string,
	    closeIcon: PropTypes.string,
	    disableStyle: PropTypes.bool,
	    styles: PropTypes.object,
	    className: PropTypes.string,
	    dismissOnClick: PropTypes.bool
	};
	/**
	 * React Cookie banner template
	 */
	var BannerContent = /** @class */ (function (_super) {
	    __extends(BannerContent, _super);
	    function BannerContent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.getStyle = function (style) {
	            var _a = _this.props, disableStyle = _a.disableStyle, _b = _a.styles, styles = _b === void 0 ? {} : _b;
	            if (!disableStyle) {
	                // apply custom styles if available
	                return __assign({}, styleUtils.getStyle(style), styles[style]);
	            }
	        };
	        _this.templateCloseIcon = function (className, onClick, style) { return (React.createElement("button", __assign({}, { onClick: onClick, style: style }),
	            React.createElement("i", __assign({}, { className: className })))); };
	        _this.templateCloseButton = function (buttonMessage, onClick, style) { return (React.createElement("button", __assign({ className: 'button-close' }, { onClick: onClick, style: style }), buttonMessage)); };
	        _this.templateLink = function (link, style) { return (React.cloneElement(link, link.props.style ? undefined : { style: style })); };
	        _this.bannerClicked = function () {
	            if (_this.props.dismissOnClick) {
	                _this.props.onAccept();
	            }
	        };
	        return _this;
	    }
	    BannerContent.prototype.render = function () {
	        var _a = this, getStyle = _a.getStyle, _b = _a.props, onAccept = _b.onAccept, className = _b.className, message = _b.message, closeIcon = _b.closeIcon, link = _b.link, _c = _b.buttonMessage, buttonMessage = _c === void 0 ? 'Got it' : _c, _wrapperProps = __rest(_b, ["onAccept", "className", "message", "closeIcon", "link", "buttonMessage"]);
	        var cookieMessageStyle = getStyle('message');
	        var wrapperProps = __assign({}, omit(_wrapperProps, Object.keys(exports.propTypes)), { className: cx('react-cookie-banner', className), style: getStyle('banner') });
	        return (React.createElement("div", __assign({}, wrapperProps, { onClick: this.bannerClicked }),
	            React.createElement("span", { className: 'cookie-message', style: cookieMessageStyle },
	                message,
	                link && this.templateLink(link, getStyle('link'))),
	            !closeIcon && this.templateCloseButton(buttonMessage, onAccept, getStyle('button')),
	            !!closeIcon && this.templateCloseIcon(closeIcon, onAccept, getStyle('icon'))));
	    };
	    BannerContent.propTypes = exports.propTypes;
	    return BannerContent;
	}(React.Component));
	exports["default"] = BannerContent;


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var omit = __webpack_require__(149);
	var react_cookie_1 = __webpack_require__(109);
	var BannerContent_1 = __webpack_require__(155);
	/**
	 * React Cookie banner dismissable with just a scroll!
	 */
	var CookieBanner = /** @class */ (function (_super) {
	    __extends(CookieBanner, _super);
	    function CookieBanner() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = { listeningScroll: false };
	        _this.addOnScrollListener = function (props) {
	            var _props = props || _this.props;
	            if (!_this.state.listeningScroll && !_this.hasAcceptedCookies() && _props.dismissOnScroll) {
	                if (window.attachEvent) {
	                    // Internet Explorer
	                    window.attachEvent('onscroll', _this.onScroll);
	                }
	                else if (window.addEventListener) {
	                    window.addEventListener('scroll', _this.onScroll, false);
	                }
	                _this.setState({ listeningScroll: true });
	            }
	        };
	        _this.removeOnScrollListener = function () {
	            if (_this.state.listeningScroll) {
	                if (window.detachEvent) {
	                    // Internet Explorer
	                    window.detachEvent('onscroll', _this.onScroll);
	                }
	                else if (window.removeEventListener) {
	                    window.removeEventListener('scroll', _this.onScroll, false);
	                }
	                _this.setState({ listeningScroll: false });
	            }
	        };
	        _this.onScroll = function () {
	            // tacit agreement buahaha! (evil laugh)
	            var dismissOnScrollThreshold = _this.props.dismissOnScrollThreshold;
	            if (window.pageYOffset > dismissOnScrollThreshold) {
	                _this.onAccept();
	            }
	        };
	        _this.getSecondsSinceExpiration = function (cookieExpiration) {
	            if (typeof cookieExpiration === 'number') {
	                return cookieExpiration;
	            }
	            var SECONDS_IN_YEAR = 31536000;
	            var SECONDS_IN_DAY = 86400;
	            var SECONDS_IN_HOUR = 3600;
	            var _cookieExpiration = __assign({ years: 0, days: 0, hours: 0 }, cookieExpiration);
	            var years = _cookieExpiration.years, days = _cookieExpiration.days, hours = _cookieExpiration.hours;
	            return (years * SECONDS_IN_YEAR) + (days * SECONDS_IN_DAY) + (hours * SECONDS_IN_HOUR);
	        };
	        _this.onAccept = function () {
	            var _a = _this.props, cookies = _a.cookies, cookie = _a.cookie, cookieExpiration = _a.cookieExpiration, path = _a.cookiePath, onAccept = _a.onAccept;
	            cookies.set(cookie, true, {
	                path: path,
	                expires: new Date(Date.now() + (_this.getSecondsSinceExpiration(cookieExpiration) * 1000))
	            });
	            onAccept({ cookie: cookie });
	            if (_this.state.listeningScroll) {
	                _this.removeOnScrollListener();
	            }
	            else {
	                _this.forceUpdate();
	            }
	        };
	        return _this;
	    }
	    CookieBanner.prototype.componentDidMount = function () {
	        this.addOnScrollListener();
	    };
	    CookieBanner.prototype.hasAcceptedCookies = function () {
	        var _a = this.props, cookies = _a.cookies, cookie = _a.cookie;
	        return cookies.get(cookie);
	    };
	    CookieBanner.prototype.templateChildren = function (children, onAccept) {
	        if (typeof children === 'function') {
	            return children(onAccept);
	        }
	        return children;
	    };
	    CookieBanner.prototype.render = function () {
	        var _a = this, onAccept = _a.onAccept, _b = _a.props, message = _b.message, link = _b.link, buttonMessage = _b.buttonMessage, closeIcon = _b.closeIcon, disableStyle = _b.disableStyle, styles = _b.styles, className = _b.className, children = _b.children, dismissOnClick = _b.dismissOnClick, props = __rest(_b, ["message", "link", "buttonMessage", "closeIcon", "disableStyle", "styles", "className", "children", "dismissOnClick"]);
	        var hasAcceptedCookies = this.hasAcceptedCookies();
	        var bannerContentProps = __assign({}, omit(props, Object.keys(CookieBanner.propTypes)), { message: message, onAccept: onAccept, link: link, buttonMessage: buttonMessage,
	            closeIcon: closeIcon, disableStyle: disableStyle, styles: styles, className: className, dismissOnClick: dismissOnClick });
	        if (hasAcceptedCookies) {
	            return null;
	        }
	        return children ?
	            this.templateChildren(children, onAccept) :
	            React.createElement(BannerContent_1["default"], __assign({}, bannerContentProps));
	    };
	    CookieBanner.prototype.componentWillReceiveProps = function (nextProps) {
	        if (nextProps.dismissOnScroll) {
	            this.addOnScrollListener(nextProps);
	        }
	        else {
	            this.removeOnScrollListener();
	        }
	    };
	    CookieBanner.prototype.componentWillUnmount = function () {
	        this.removeOnScrollListener();
	    };
	    CookieBanner.propTypes = __assign({}, BannerContent_1.propTypes, { children: PropTypes.oneOfType([
	            PropTypes.node,
	            PropTypes.func
	        ]), onAccept: PropTypes.func, cookies: PropTypes.instanceOf(react_cookie_1.Cookies), cookie: PropTypes.string, cookieExpiration: PropTypes.oneOfType([
	            PropTypes.number,
	            PropTypes.shape({
	                years: PropTypes.number,
	                days: PropTypes.number,
	                hours: PropTypes.number
	            })
	        ]), cookiePath: PropTypes.string, dismissOnScroll: PropTypes.bool, dismissOnScrollThreshold: PropTypes.number });
	    CookieBanner.defaultProps = {
	        onAccept: function () { },
	        dismissOnScroll: true,
	        cookies: new react_cookie_1.Cookies(),
	        cookie: 'accepts-cookies',
	        cookieExpiration: { years: 1 },
	        buttonMessage: 'Got it',
	        dismissOnScrollThreshold: 0,
	        styles: {}
	    };
	    return CookieBanner;
	}(React.Component));
	exports["default"] = CookieBanner;


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var react_cookie_1 = __webpack_require__(109);
	var CookieBanner_1 = __webpack_require__(156);
	exports["default"] = react_cookie_1.withCookies(CookieBanner_1["default"]);


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var CookieBanner_1 = __webpack_require__(156);
	var CookieBannerUniversal_1 = __webpack_require__(330);
	exports.CookieBannerUniversal = CookieBannerUniversal_1["default"];
	var BannerContent_1 = __webpack_require__(155);
	exports.BannerContent = BannerContent_1["default"];
	exports["default"] = CookieBanner_1["default"];
	var react_cookie_1 = __webpack_require__(109);
	exports.Cookies = react_cookie_1.Cookies;
	exports.CookiesProvider = react_cookie_1.CookiesProvider;


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	"use strict";
	exports.__esModule = true;
	var styles = {
	    icon: {
	        background: 'none',
	        border: 'none',
	        boxShadow: 'none',
	        padding: '0',
	        position: 'absolute',
	        fontSize: '1em',
	        top: '50%',
	        marginTop: '-0.5em',
	        right: '1em',
	        color: 'white',
	        cursor: 'pointer'
	    },
	    link: {
	        color: '#F0F0F0',
	        textDecoration: 'underline',
	        marginLeft: '10px'
	    },
	    button: {
	        position: 'absolute',
	        top: '50%',
	        right: '35px',
	        lineHeight: '24px',
	        marginTop: '-12px',
	        padding: '0 8px',
	        backgroundColor: 'rgba(255, 255, 255, 0.6)',
	        border: 'none',
	        borderRadius: '3px',
	        boxShadow: 'none',
	        fontSize: '12px',
	        fontWeight: '500',
	        color: '#242424',
	        cursor: 'pointer'
	    },
	    message: {
	        lineHeight: '45px',
	        fontWeight: 500,
	        color: '#F0F0F0'
	    },
	    banner: {
	        position: 'relative',
	        textAlign: 'center',
	        backgroundColor: '#484848',
	        width: '100%',
	        height: '45px',
	        zIndex: '10000'
	    }
	};
	var getStyle = function (style) { return styles[style]; };
	exports.getStyle = getStyle;


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _universalCookie = __webpack_require__(110);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _universalCookie2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _universalCookie = __webpack_require__(110);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookiesProvider = function (_Component) {
	  _inherits(CookiesProvider, _Component);
	
	  function CookiesProvider(props) {
	    _classCallCheck(this, CookiesProvider);
	
	    var _this = _possibleConstructorReturn(this, (CookiesProvider.__proto__ || Object.getPrototypeOf(CookiesProvider)).call(this, props));
	
	    if (props.cookies) {
	      _this.cookies = props.cookies;
	    } else {
	      _this.cookies = new _universalCookie2.default();
	    }
	    return _this;
	  }
	
	  _createClass(CookiesProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        cookies: this.cookies
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return CookiesProvider;
	}(_react.Component);
	
	CookiesProvider.propTypes = {
	  children: _propTypes.node,
	  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default)
	};
	CookiesProvider.childContextTypes = {
	  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
	};
	exports.default = CookiesProvider;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(333);
	
	Object.defineProperty(exports, 'Cookies', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cookies).default;
	  }
	});
	
	var _CookiesProvider = __webpack_require__(334);
	
	Object.defineProperty(exports, 'CookiesProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CookiesProvider).default;
	  }
	});
	
	var _withCookies = __webpack_require__(335);
	
	Object.defineProperty(exports, 'withCookies', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withCookies).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withCookies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _universalCookie = __webpack_require__(110);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _hoistNonReactStatics = __webpack_require__(64);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function withCookies(Component) {
	  function Wrapper(props, _ref) {
	    var cookies = _ref.cookies;
	
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(Component, _extends({}, remainingProps, {
	      cookies: cookies,
	      ref: wrappedComponentRef
	    }));
	  }
	
	  Wrapper.displayName = 'withCookies(' + (Component.displayName || Component.name) + ')';
	  Wrapper.WrappedComponent = Component;
	
	  Wrapper.propTypes = {
	    wrappedComponentRef: _propTypes.func
	  };
	
	  Wrapper.contextTypes = {
	    cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
	  };
	
	  return (0, _hoistNonReactStatics2.default)(Wrapper, Component);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(257);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(153);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(339);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
	O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
	function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
	function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
	ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
	d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
	var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
	Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),

/***/ 1441:
/***/ (function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonBase = __webpack_require__(79);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _SvgIcon = __webpack_require__(93);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _styles = __webpack_require__(11);
	
	var _reactAnimatedCss = __webpack_require__(1329);
	
	var _styles2 = __webpack_require__(587);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	__webpack_require__(769);
	
	var _menuOpen = __webpack_require__(1419);
	
	var _menuOpen2 = _interopRequireDefault(_menuOpen);
	
	var _ct = __webpack_require__(460);
	
	var _ct2 = _interopRequireDefault(_ct);
	
	var _refresh = __webpack_require__(1425);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      hovering: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    // Livechat
	    (function (t) {
	      window.lpTag = window.lpTag || {};if (typeof window.lpTag._tagCount === "undefined") {
	        window.lpTag = { site: t, section: lpTag.section || "", autoStart: lpTag.autoStart === false ? false : true, ovr: lpTag.ovr || {}, _v: "1.6.0", _tagCount: 1, protocol: "https:", events: { bind: function bind(t, e, o) {
	              lpTag.defer(function () {
	                lpTag.events.bind(t, e, o);
	              }, 0);
	            }, trigger: function trigger(t, e, o) {
	              lpTag.defer(function () {
	                lpTag.events.trigger(t, e, o);
	              }, 1);
	            } }, defer: function defer(t, e) {
	            if (e == 0) {
	              this._defB = this._defB || [];this._defB.push(t);
	            } else if (e == 1) {
	              this._defT = this._defT || [];this._defT.push(t);
	            } else {
	              this._defL = this._defL || [];this._defL.push(t);
	            }
	          }, load: function load(t, e, o) {
	            var s = this;setTimeout(function () {
	              s._load(t, e, o);
	            }, 0);
	          }, _load: function _load(t, e, o) {
	            var s = t;if (!t) {
	              s = this.protocol + "//" + (this.ovr && this.ovr.domain ? this.ovr.domain : "lptag.liveperson.net") + "/tag/tag.js?site=" + this.site;
	            }var n = document.createElement("script");n.setAttribute("charset", e ? e : "UTF-8");if (o) {
	              n.setAttribute("id", o);
	            }n.setAttribute("src", s);document.getElementsByTagName("head").item(0).appendChild(n);
	          }, init: function init() {
	            this._timing = this._timing || {};this._timing.start = new Date().getTime();var t = this;if (window.attachEvent) {
	              window.attachEvent("onload", function () {
	                t._domReady("domReady");
	              });
	            } else {
	              window.addEventListener("DOMContentLoaded", function () {
	                t._domReady("contReady");
	              }, false);window.addEventListener("load", function () {
	                t._domReady("domReady");
	              }, false);
	            }if (typeof window._lptStop == "undefined") {
	              this.load();
	            }
	          }, start: function start() {
	            this.autoStart = true;
	          }, _domReady: function _domReady(t) {
	            if (!this.isDom) {
	              this.isDom = true;this.events.trigger("LPT", "DOM_READY", { t: t });
	            }this._timing[t] = new Date().getTime();
	          }, vars: lpTag.vars || [], dbs: lpTag.dbs || [], ctn: lpTag.ctn || [], sdes: lpTag.sdes || [], ev: lpTag.ev || [] };lpTag.init();
	      } else {
	        window.lpTag._tagCount += 1;
	      }window.cafexAssistBootstrap = {};window.cafexAssistBootstrap.laBootstrapLoaded = false;window.cafexAssistBootstrap.cobrowseState;window.cafexAssistBootstrap.bootstrapLa = function (t) {
	        var e = document.getElementById("assist-cobrowse-bootstrap-script");if (e) {
	          e.parentNode.removeChild(e);
	        }var o = t + "/assist-bootstrap/assist-bootstrap.js";var s = document.createElement("script");s.id = "assist-cobrowse-bootstrap-script";s.type = "text/javascript";s.src = o;window.cafexAssistBootstrap.cobrowseBootstrapLoaded = function () {
	          window.cafexAssistBootstrap.laBootstrapLoaded = true;switch (window.cafexAssistBootstrap.cobrowseState) {case "accepted":
	              window.cafexAssistBootstrap.cobrowseAccepted(window.cafexAssistBootstrap.agentId);break;case "rejected":
	              window.cafexAssistBootstrap.cobrowseRejected(window.cafexAssistBootstrap.agentId);break;}
	        };document.head.appendChild(s);
	      };if (sessionStorage.getItem("cobrowseServer")) {
	        window.cafexAssistBootstrap.bootstrapLa(sessionStorage.getItem("cobrowseServer"));
	      }lpTag.events.bind({ eventName: "cobrowseOffered", appName: "*", func: function func(t) {
	          console.log(t);window.cafexAssistBootstrap.cobrowseState = "offered";var e = document.querySelectorAll("[data-assist-a" + t.agentId + "]");var o = JSON.parse(atob(e[e.length - 1].dataset["assistA" + t.agentId]));console.log(o);if (y(o.server) === false) {
	            return;
	          }sessionStorage.setItem("cobrowseServer", o.server);window.cafexAssistBootstrap.bootstrapLa(o.server);
	        }, async: true });lpTag.events.bind({ eventName: "cobrowseAccepted", appName: "*", func: function func(t) {
	          console.log(t);window.cafexAssistBootstrap.cobrowseState = "accepted";window.cafexAssistBootstrap.agentId = t.agentId;if (window.cafexAssistBootstrap.laBootstrapLoaded) {
	            window.cafexAssistBootstrap.cobrowseAccepted(t.agentId);
	          }
	        }, async: true });lpTag.events.bind({ eventName: "cobrowseDeclined", appName: "*", func: function func(t) {
	          console.log(t);window.cafexAssistBootstrap.cobrowseState = "rejected";window.cafexAssistBootstrap.agentId = t.agentId;if (window.cafexAssistBootstrap.laBootstrapLoaded) {
	            window.cafexAssistBootstrap.cobrowseRejected(t.agentId);
	          }
	        }, async: true });function e(t, e) {
	        var s = o(t, e);document.dispatchEvent(s);
	      }function o(t, e) {
	        var o = void 0;if (typeof window.CustomEvent === "function") {
	          o = new CustomEvent(t, e);
	        } else {
	          var _s = e || { bubbles: false, cancelable: false, detail: undefined };o = document.createEvent("CustomEvent");o.initCustomEvent(t, _s.bubbles, _s.cancelable, _s.detail);
	        }return o;
	      }document.addEventListener("click", function (t) {
	        if (t.target.dataset && t.target.dataset.event !== undefined) {
	          try {
	            var _o = JSON.parse(t.target.dataset.event);var _s2 = p(_o.useRecentData, t.target.parentElement.dataset.bootStrap);d(_o);r(_o);h(t.target.parentElement.dataset.bootStrap, function (t) {
	              u(t);e(_o.event, _s2);
	            });
	          } catch (e) {
	            console.log("could not process" + t.target.dataset.event + " " + e);
	          }
	        }
	      });lpTag.events.bind({ eventName: "state", appName: "*", func: function func(t) {
	          if (t.state === "ended") {
	            i();
	          }
	        }, async: true });var s = "liveAssistScripts";var n = "liveAssistElements";var a = "deleteLiveAssistScript";function i() {
	        var t = document.querySelectorAll("[data-event]");t.forEach(function (t) {
	          var e = JSON.parse(t.dataset.event);d(e, true);
	        });
	      }function d(t, e) {
	        var o = document.getElementById(t.id);if (t.oneTime || e) {
	          o.disabled = true;if (typeof t.disabledStyle !== "undefined") {
	            o.style.cssText = t.disabledStyle;
	          }o.style.cssText += "pointer-events: none;";
	        }
	      }function r(t) {
	        var e = "element already exists in local storage list";g(sessionStorage, t, e, n);
	      }function c() {
	        var t = JSON.parse(sessionStorage.getItem(n));var e = [];for (var _o2 in t) {
	          if (t[_o2].oneTime) {
	            e.push(f(t[_o2]));
	          }
	        }if (e.length !== 0) {
	          l(e);
	        }
	      }function l(t) {
	        var e = document.head || document.getElementsByTagName("head")[0];var o = document.createElement("style");o.type = "text/css";t.forEach(function (t) {
	          o.appendChild(document.createTextNode(t));
	        });e.appendChild(o);
	      }function f(t) {
	        var e = "#" + t.id + "{";var o = t.disabledStyle.split(";");o.forEach(function (t) {
	          e += t + " !important;";
	        });e += "pointer-events: none;";e += "}";return e;
	      }function p(t, e) {
	        var o = { detail: { data: e } };if (t) {
	          var _t = JSON.parse(e).id;var _s3 = document.querySelectorAll("[data-boot-strap]");for (var _e = _s3.length - 1; _e > 0; _e--) {
	            var _n = _s3[_e].dataset["bootStrap"];if (JSON.parse(_n).id === _t) {
	              o = { detail: { data: _n } };break;
	            }
	          }
	        }return o;
	      }function u(t) {
	        var e = "script already exists in local storage list";g(localStorage, t, e, s);
	      }function g(t, e, o, s) {
	        var n = JSON.parse(t.getItem(s));if (!n) {
	          n = {};
	        }if (n[e.id] === undefined) {
	          n[e.id] = e;t.setItem(s, JSON.stringify(n));console.log("adding" + e.id + " to storage");
	        } else {
	          console.log(o);
	        }
	      }function m(t) {
	        w(localStorage, t, s);
	      }function w(t, e, o) {
	        var s = JSON.parse(t.getItem(o));if (delete s[e] === false) {
	          console.log("script" + e + "does not exist in list");
	        }t.setItem(o, JSON.stringify(s));
	      }function v(t) {
	        var e = document.getElementById(t);if (e) {
	          e.parentNode.removeChild(e);e = null;console.log("script" + t + " removed from dom");
	        }
	      }function b(t, e) {
	        var o = document.getElementById(t.id);if (y(t.bootstrapJs) === false) {
	          console.log("script not in valid domain");return;
	        }if (o) {
	          o.parentNode.removeChild(o);o = null;
	        }o = document.createElement("script");o.id = t.id;o.async = true;o.onload = function () {
	          e(t);
	        };o.src = t.bootstrapJs;document.body.appendChild(o);
	      }function h(t, e) {
	        var o = JSON.parse(t);if (o) {
	          b(o, e);return true;
	        }return false;
	      }function S() {
	        var t = JSON.parse(localStorage.getItem(s));console.log("restoring scripts using local storage");
	        var _loop = function _loop(_e2) {
	          b(t[_e2], function () {
	            console.log("script" + _e2 + "restored");
	          });
	        };
	
	        for (var _e2 in t) {
	          _loop(_e2);
	        }
	      }document.addEventListener(a, function (t) {
	        v(t.detail.id);m(t.detail.id);
	      }, false);document.addEventListener("DOMContentLoaded", function (t) {
	        S();c();
	      });function y(t) {
	        var e = [".cafex.com", ".liveassistcloud.com", ".liveassistfor365.com"];var o = false;var s = document.createElement("a");s.href = t;var n = s.hostname;for (var _t2 = 0; _t2 < e.length; _t2++) {
	          var _s4 = e[_t2];var _a = n.indexOf(_s4);if (_a != -1 || _a == n.length - _s4.length) {
	            o = true;break;
	          }
	        }if (!o) {
	          console.log("Unexpected domain " + n + " aborting...");
	        }return o;
	      }
	    })(28944727);
	  };
	
	  Header.prototype.hoverButton = function hoverButton() {
	    this.setState({
	      hovering: !this.state.hovering
	    });
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        toggle = _props.toggle,
	        preview = _props.preview,
	        classes = _props.classes,
	        metaData = _props.metaData;
	    var hovering = this.state.hovering;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _ButtonBase2.default,
	        {
	          className: classes.navButton,
	          onClick: function onClick() {
	            return toggle();
	          },
	          onMouseOver: function onMouseOver() {
	            _this2.hoverButton();
	          },
	          onMouseOut: function onMouseOut() {
	            _this2.hoverButton();
	          },
	          tabIndex: '1'
	        },
	        _react2.default.createElement('img', {
	          className: hovering ? [classes.navButtonIcon, 'hovering'].join(' ') : classes.navButtonIcon,
	          src: _menuOpen2.default,
	          alt: 'Navigation icon'
	        })
	      ),
	      preview && _react2.default.createElement(
	        _Button2.default,
	        {
	          variant: 'fab',
	          mini: true,
	          color: 'primary',
	          className: classes.previewButton,
	          onClick: function onClick() {
	            fetch('/__refresh', { method: 'post' });
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: _refresh2.default })
	        )
	      ),
	      _react2.default.createElement('img', { src: _ct2.default, className: classes.headerLogo })
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Header);
	module.exports = exports['default'];

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var styles = function styles(theme) {
	  var _root, _slogo, _headerLogo, _navButtonIcon;
	
	  return {
	    root: (_root = {
	      fontSize: '80%'
	    }, _root[theme.breakpoints.up('sm')] = {
	      fontSize: '100%'
	    }, _root),
	    slogo: (_slogo = {
	      display: 'inline',
	      height: 40,
	      marginRight: 5
	    }, _slogo[theme.breakpoints.down('xs')] = {
	      display: 'none'
	    }, _slogo),
	    headerLogo: (_headerLogo = {
	      zIndex: 999,
	      display: 'inline',
	      position: 'fixed',
	      height: 35,
	      right: 85,
	      top: 32
	    }, _headerLogo[theme.breakpoints.down('sm')] = {
	      display: 'none'
	    }, _headerLogo),
	    navButton: {
	      zIndex: 9,
	      position: 'fixed',
	      top: 30,
	      right: 30,
	      cursor: 'pointer',
	      width: '250'
	      // '&:focus': {
	      //   outline: '1px dashed'
	      // }
	    },
	    navButtonIcon: (_navButtonIcon = {
	      float: 'right',
	      height: 30
	    }, _navButtonIcon[theme.breakpoints.up('sm')] = {
	      height: 40
	    }, _navButtonIcon),
	    previewButton: {
	      // background: 'rgba(118,66,210,.5)',
	      zIndex: 9,
	      position: 'fixed',
	      top: 30,
	      left: 30,
	      cursor: 'pointer',
	      width: '250',
	      '& p': {
	        display: 'inline',
	        color: 'rgb(255,255,255,1)',
	        marginLeft: 7
	      },
	      '& img': {
	        width: 20,
	        verticalAlign: 'middle',
	        marginTop: -10
	      }
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Drawer = __webpack_require__(481);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(591);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	var _slogo = __webpack_require__(1426);
	
	var _slogo2 = _interopRequireDefault(_slogo);
	
	var _datascience = __webpack_require__(1430);
	
	var _datascience2 = _interopRequireDefault(_datascience);
	
	var _develop = __webpack_require__(1431);
	
	var _develop2 = _interopRequireDefault(_develop);
	
	var _devops = __webpack_require__(1432);
	
	var _devops2 = _interopRequireDefault(_devops);
	
	var _dynamics = __webpack_require__(1433);
	
	var _dynamics2 = _interopRequireDefault(_dynamics);
	
	var _taas = __webpack_require__(1436);
	
	var _taas2 = _interopRequireDefault(_taas);
	
	var _fixed = __webpack_require__(1434);
	
	var _fixed2 = _interopRequireDefault(_fixed);
	
	var _ct = __webpack_require__(460);
	
	var _ct2 = _interopRequireDefault(_ct);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        open = _props.open,
	        toggle = _props.toggle;
	
	    return _react2.default.createElement(
	      _Drawer2.default,
	      {
	        transitionDuration: {
	          enter: _constants.DRAWER.enter,
	          exit: _constants.DRAWER.exit
	        },
	        anchor: 'right',
	        open: open,
	        onClose: function onClose() {
	          return toggle();
	        }
	      },
	      _react2.default.createElement(
	        'nav',
	        { className: classes.nav },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement('img', {
	            src: _ct2.default,
	            className: classes.navLogo,
	            onClick: function onClick() {
	              return toggle();
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.navItems },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/service/develop' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navDevelop].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _develop2.default, alt: 'Development logo' }),
	              'Develop'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/service/dynamics_365' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navDynamics].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _dynamics2.default, alt: 'Dynamics logo' }),
	              'Dynamics'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/service/devops' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navDevops].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _devops2.default, alt: 'Devops logo' }),
	              'Devops'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/service/datascience' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navDatascience].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _datascience2.default, alt: 'Datascience logo' }),
	              'DataScience'
	            )
	          ),
	          _react2.default.createElement('div', { className: classes.divider }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/method/ct-method-taas' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navTaas].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _taas2.default, alt: 'TaaS logo' }),
	              'Team as a Service'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/method/ct-method-fixed' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: [classes.navItem, classes.navFixed].join(' '),
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              _react2.default.createElement('img', { src: _fixed2.default, alt: 'TaaS logo' }),
	              'Fixed Price Projects'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/things' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Products'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/blog' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Blog'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/studies' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Clients'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/careers' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Careers'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/about' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'About'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Contact'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                gutterBottom: true,
	                className: classes.navItem,
	                onClick: function onClick() {
	                  return toggle();
	                }
	              },
	              'Home'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Navigation);
	module.exports = exports['default'];

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var styles = function styles(theme) {
	  return {
	    nav: {
	      minWidth: '30vw',
	      background: '#333',
	      flex: 1,
	      paddingBottom: '40px',
	      '& a': {
	        textDecoration: 'none'
	      },
	      '& a:hover': {
	        textDecoration: 'underline',
	        textDecorationColor: 'rgba(255,255,255,.7)',
	        textUnderlinePosition: 'under',
	        '& p': {
	          color: 'rgba(255,255,255,.7)'
	        }
	      }
	    },
	    navLogo: {
	      height: 50,
	      margin: '3rem 0 1rem 3rem'
	    },
	    navItems: {
	      marginLeft: '3rem'
	    },
	    navItem: {
	      color: 'rgba(255,255,255,.5)',
	      textTransform: 'uppercase',
	      margin: theme.spacing.unit,
	      fontWeight: 800,
	      '& img': {
	        verticalAlign: 'middle',
	        height: 35,
	        marginRight: 20
	      }
	    },
	    navDatascience: {
	      color: theme.brand && theme.brand.datascience.navText
	    },
	    navDevelop: {
	      color: theme.brand && theme.brand.develop.navText
	    },
	    navDevops: {
	      color: theme.brand && theme.brand.devops.navText
	    },
	    navDynamics: {
	      color: theme.brand && theme.brand.dynamics_365.navText
	    },
	    navTaas: {
	      color: theme.brand && theme.brand.taas.navText
	    },
	    navFixed: {
	      color: theme.brand && theme.brand.fixed.navText,
	      marginBottom: theme.spacing.unit * 3
	    },
	    navFooter: {
	      background: '#333',
	      padding: '3rem',
	      '& img': {
	        width: 100
	      }
	    },
	    divider: {
	      marginTop: theme.spacing.unit * 2,
	      marginBottom: theme.spacing.unit * 2,
	      border: 'none',
	      borderTop: '1px solid #444',
	      width: '70%'
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(612);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsupportedPage = function UnsupportedPage(props) {
	  var classes = props.classes;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(classes.errorPage, 'error404') },
	    _react2.default.createElement(
	      'div',
	      { className: classes.unsupported },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { conatiner: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display3' },
	                'Sorry!'
	              )
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'subheading', gutterBottom: true },
	                'Right now this site doesn\'t work that great on older browsers, for the time being please try on your mobile, ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.google.co.uk/chrome/', target: '_blank' },
	                  'chrome'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.mozilla.org/en-GB/firefox/new/', target: '_blank' },
	                  'firefox'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.microsoft.com/en-gb/windows/microsoft-edge', target: '_blank' },
	                  'edge'
	                ),
	                ' or ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://support.apple.com/downloads/safari', target: '_blank' },
	                  'safari'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                null,
	                'Many thanks'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(UnsupportedPage);
	module.exports = exports['default'];

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	
	    errorPage: {
	      position: 'absolute',
	      margin: 0,
	      width: '100%',
	      height: '100vh'
	    },
	
	    unsupported: {
	      height: '100%',
	      '& h1': {
	        display: 'block',
	        fontWeight: 800,
	        color: 'rgba(255,255,255,1)'
	      },
	      '& h3': {
	        display: 'block',
	        fontWeight: 400,
	        color: 'rgba(255,255,255,1)'
	      },
	      '& p': {
	        marginTop: theme.spacing.unit * 3,
	        color: 'rgba(255,255,255,1)'
	      }
	    }
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ct.67515269.png";

/***/ }),

/***/ 1419:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEzMXB4IiBoZWlnaHQ9IjEyNnB4IiB2aWV3Qm94PSIwIDAgMTMxIDEyNiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDguMSAoNDcyNTApIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdyb3VwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwIj4KICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwiIGZpbGwtb3BhY2l0eT0iMC43IiBmaWxsPSIjRkZGRkZGIiBjeD0iNjUuNSIgY3k9IjYzIiByeD0iNjUuNSIgcnk9IjYzIj48L2VsbGlwc2U+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtcGF0aCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjUiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgeD0iMzQiIHk9IjYwIiB3aWR0aD0iNjQiIGhlaWdodD0iNiIgcng9IjMiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1wYXRoIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iNSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiB4PSIzNCIgeT0iODEiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLXBhdGgiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSI1IiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHg9IjM0IiB5PSIzOCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjYiIHJ4PSIzIj48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 1425:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkFGQUZBIiB4bWxuczp4PSJodHRwOi8vbnMuYWRvYmUuY29tL0V4dGVuc2liaWxpdHkvMS4wLyIgeG1sbnM6aT0iaHR0cDovL25zLmFkb2JlLmNvbS9BZG9iZUlsbHVzdHJhdG9yLzEwLjAvIiB4bWxuczpncmFwaD0iaHR0cDovL25zLmFkb2JlLmNvbS9HcmFwaHMvMS4wLyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwMCAxMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxtZXRhZGF0YT48c2Z3IHhtbG5zPSJodHRwOi8vbnMuYWRvYmUuY29tL1NhdmVGb3JXZWIvMS4wLyI+PHNsaWNlcz48L3NsaWNlcz48c2xpY2VTb3VyY2VCb3VuZHMgd2lkdGg9IjE0NDcuMiIgaGVpZ2h0PSIxNDQ0LjIiIHg9IjEiIHk9Ii0xNDQ2LjEiIGJvdHRvbUxlZnRPcmlnaW49InRydWUiPjwvc2xpY2VTb3VyY2VCb3VuZHM+PC9zZnc+PC9tZXRhZGF0YT48cGF0aCBkPSJNMi4zLDMzLjhDMi4zLDI4LDcsMjMuMiwxMi45LDIzLjJINDRsLTcuOC03LjhjLTEtMS0xLTIuNiwwLTMuNWMxLTEsMi42LTEsMy41LDBsMTIsMTJjMSwxLDEsMi42LDAsMy41bC0xMiwxMiAgYy0wLjUsMC41LTEuMSwwLjctMS44LDAuN3MtMS4zLTAuMi0xLjgtMC43Yy0xLTEtMS0yLjYsMC0zLjVsNy44LTcuOEgxMi45Yy0zLjEsMC01LjYsMi41LTUuNiw1LjZ2NDQuNGMwLDMuMSwyLjUsNS42LDUuNiw1LjZoNzQuMyAgYzMuMSwwLDUuNi0yLjUsNS42LTUuNlYzMy44YzAtMy4xLTIuNS01LjYtNS42LTUuNkg2NS42Yy0xLjQsMC0yLjUtMS4xLTIuNS0yLjVzMS4xLTIuNSwyLjUtMi41aDIxLjZjNS44LDAsMTAuNiw0LjcsMTAuNiwxMC42ICB2NDQuNGMwLDUuOC00LjcsMTAuNi0xMC42LDEwLjZIMTIuOUM3LDg4LjgsMi4zLDg0LjEsMi4zLDc4LjJWMzMuOHoiPjwvcGF0aD48L3N2Zz4="

/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slogo.6ecfaf46.svg";

/***/ }),

/***/ 1430:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1431:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABO1JREFUWAntVm1sU1UYPu9pyxoSGUN0ZG44IjPyoUiqC65dyDK2dib6B5hxXReiJA4jCoRFQkz8pRFijIZgjAY1W6fLlqBIsq1uZNN2c2RN/CJImEqELQLCVGRuXdtzfE7ZXe7Y2l7d5YdJb9Kec9+P5zznfd/z3sNY5slEIBOB/3cESE+/MdjxLSO2FsIYk2xMMrqO+QVG8mfJ2GkrswYX5xYOPlpUFNH73cr5DIJNoc5vpJTriNgkCF5mRLfhPVtPgEAamzjKiY54ne4v9bpbMed6ULA9mngnvstXWlXgc3kWL1220s5t9gKykgPE6xHJXsnklrgQX2BDPR/3d63XY5g9nxHBlr4T90RldAjR+9BX6nkq2WI953rswyORWuhfAeEcRPSlOqfnYDL7+chnEFRATaGOEyC4Pj/fnle2omwiFXhruCs7MiEOSCmeAclDda6q51PZ/xfdjBQrAEn8PRWV4ZHJzekAqx+q+NPnctejVt/Epnb6Q5270vn8W/0sggV5Cz5ljP4A1e1GwXxO9x7U5yeozVc/GujONepnxG4WwURaibXAeWPjycAKIyBEJC2c70fks2LxWIMRH6M2swgqR27hfrQXNBvhNQpUU+I+g/poZ1LuOB4OLzTql85uToLeDRX9OD3DcN6aDkCvJ05h1OLCa+NXV+nl85nPSVClDKCf4feAf6B7tdEF0MR/UraI/VqjPuns5iSonMhiudG0Y7Fn04FoesHiS27MZY4mm+9oTQaw4JGK3kgoMCSYrGsNdR2sdlWcT2aryUlSEU4yE1KOaDL92CqlJRoKlElOq6RkBcTkdcFohJPlO29JeXgqc3oXtNcUj78vsEUI0YYW8j2nBY95neW/JDNvHxrKunLxxwvQ38G5rbjWuWlQb4seWS8k248Fl0iSX6OILkqiOEgi2vQg9hVHcRwH2WNeV2W75puSoDLCl+UN7Ha36o0g+jYn3pZXYjtVRmUxpVenvW2wNzcSjeyTQr6AOjxX63KvRDSE0qunKdj5PoatuBXtzcpZ/kH1mjWTCcXUn8LwhwLtCJcbRHfjM/uWpk9LUBkikjuFFK+pE5pwJIpi/AvOUchuR1qnSwUE92GBAwk75asix+RhXNU21rgqQppcG8PhsO3MxJV3YbPZQuTzOj3HNJ0akx4SvVGt033IzqmAiDcgMh0gNooULcLOc5Eu3LzoEmSnp3x+1fsijC+CtH8ucs3BYM4PE791AqfYynnxzeQUzvTO9aBzzatLPKOQvz71S5io3TscjrhKJxbhSNM1pOlhKBuVQWNf4E4mRCHK42X1rn+a+gMlIj7mx6X4K7aIHq9Z5x7T67W5oRRrxulG1FoYER235ywvj4wOb2MknkP93o/LxFX4hrAYDhGNo3JXQ14O2d66Us/hVLiGI5gKZFpHzIrU3xf5/fxZdPq7kdpTjOPgSBnBeyHIZaMJxdHJO6w269M1GzZdmvZNMjGXIGPLQGQpiKG30Q6c5o4k6xoWm0aw5WT3vZOT0VzUY2/+XVlV6S67RhkaOsVGwKLRWKWyszLeYBY5hWcaQfTDbcA7+6SrMqyAzXpMIdgcDDjQrB2ou2aziGk4ptRgnOQetJBxQfSOBmzWOO8INg98XoQ28gRayJE6p/uyWcQ0nHkTlFGxHRfUvznZ1Fcm82QikIlAJgI3ReAfvi62hlUOjcUAAAAASUVORK5CYII="

/***/ }),

/***/ 1432:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1433:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1434:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABUlJREFUWAntV1tMXFUUPecMD5nQimkCyh1EG0sM2hT9aE00AlqNbU1areILkw60NNFAB/TDD1rHV2J8FMpDA1KmH/2wWK31AWqaCsSY/hhbjaVaP5SZIUB9ADJDh2Fmu/ZFxls63Lk0dhITTgLnsfdeZ92999nnjBBLbckDSx4w9YA0lV4mIXV12fz+nmYSYrOSok5zeQ4ttFXSCVJTdbovMnlIEG1mUlKKiFS2cm3X/nfjkUwqwdHWpzKnp6eOEtFdRjJmJC0T9DU4G/HVj0klOnPXXLdblrpnOFQ+X88ebLATGx511Hq4j9v+bHBlTdLY5xCuZQUpZRBE7bBFx1MREaQed9R1dhkBlHFiNka+3Ii/7GhUPOc/+euXvoYdRcijL4SgPdghB7aFZvYBGndCvpYJKSWrMT7B+kSyVQr5LUjahKQ3ec3YLBNMT8t4CJ95mI1B6A6iMEDnQiWP2O2p9xuB54+VtH0Gvx1RSm3FoWgBiJ11cEi8y5ar9fBhpyCxd76d5RCzIQhJX6OzF0B3xoCk6He4PCUgDwdbb0gZL/AcYPhknstzcCFLywT/aKu6MhAIe0DzgflgCNt7aWn2iuyn35qcL4s3H22tvCEUipzVZSplTZ6r47t4erxmOcTBYPiTOXLw1nEpU29B/xWDIH8eDk0H3+exlTYdJs5HRFX8YkaOdSwTlEQDIDQC2Bc1bcO9jtp3TmpF+aVKiVeBM4xEH2DARG2opTIfX+RiPdi8nUjfcogTAVmRn9tfsSw0Ee2Hx4tAzqtdlV8gne7zZraWPWgGYkXm3bdt1fkJ+prJIbYhkWIrS0SOcVOsgF+qDpFb+RsH1+HUl1Mkuh3ZmgasKZuST+TWdOh1MBH2JYd4pHF7TpiiuE/pbuTUtfDKCtQZW2xDonSEMYcExZyAzc4oW0p57q6Ob2J6CQaLJshXVkCMu1HD+Fq7IgE+n1TwlidISo8j975OWVYWSWRjlC+K4FCD89YIEd8m1+sgUg6hPn8kouoUrqnf4K3oHLhNKaQbjeCmOHtNjefc3Ppie8sEh5u3rQ7PiH74IwubTCN8r+EUvmIl0RdLyqhviaBeHsbpB3gkDwajKjWtOLe6/YwR6HKNYwlstkFogl7SyeFJRCLlkWSRY04J6yAfChyIKv0DpHTn1Xb06uMk/UtIMCAmysAlA9fcZIbKbEoSr9g2iUNMdNusNvWtqGmeiFmaDPCUakNt3ILy0q45Nri5tOg/lHw9btTNKtSeD81e30ZoUw/6WnYUkBTFbIBiFqau2gyjscm4EPrZyNt6v7/72Ozru/sYz3kddqavbyPuggTxMK0X0zMD8MRK3YDEFr9/7KfhfZU3GwHijTNsmZuQEh+wDMWwZPb1LUp4zuss57GVFrfM+PZWlJGI6r9V+c0G2J9xUG4HIOeiT8vKX5Wo/kFf+hudx5ngv0Rkn6O2sxQYcKS1FteDIPcMm6MYd2v2tALkyz2pqWIdlqawscM/NvioGfzvTdXL/Y0Vhy8kxxZUzOssN7M3yuISxBfqOSKVbJM728NscHX1ge/R9fEYuXQT9wu1qcjkp/iQB1mOCPTOvr5FL895PRj562MeW2lxCcLQqxsTFcyB8ClEPqzkuRJycG59gf403ziIwMuatnG9/vpGz/N/1i29vhkb+hc3b4PzdXzqsxAGhFT1isTpqIhWIXG2wiVhJeVqzdX548WW//1K3Dpos6c+HwmENyKUhXigNFzwPpK0G79rk0KOPzeuB1kw1FZljwTDL0BhE5I9F8+pU/DkG1rdAcv5wzhLbckD/3cP/A3SbgUkxYMETwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(447);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCookieBanner = __webpack_require__(331);
	
	var _reactCookieBanner2 = _interopRequireDefault(_reactCookieBanner);
	
	var _CssBaseline = __webpack_require__(479);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _webfontloader = __webpack_require__(1440);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	var _detectBrowser = __webpack_require__(753);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(617);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	var _default = __webpack_require__(659);
	
	var _header = __webpack_require__(586);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _nav = __webpack_require__(590);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _unsupported = __webpack_require__(611);
	
	var _unsupported2 = _interopRequireDefault(_unsupported);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var browser = (0, _detectBrowser.detect)();
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      open: false,
	      preview: ({"NODE_ENV":"production","PUBLIC_DIR":"/home/vsts/work/1/s/public"}).ENABLE_GATSBY_REFRESH_ENDPOINT,
	      unsupported: false
	    }, _this.componentDidMount = function () {
	      _webfontloader2.default.load({
	        typekit: {
	          id: 'kij6mms'
	        }
	      });
	
	      // if (
	      //   browser &&
	      //   !['chrome', 'firefox', 'safari', 'edge', 'ios', 'android'].includes(browser.name)
	      // ) {
	      //   this.setState({ unsupported: true})
	      // }
	    }, _this.toggle = function () {
	      _this.setState({
	        open: !_this.state.open
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        classes = _props.classes,
	        data = _props.data;
	    var _state = this.state,
	        open = _state.open,
	        preview = _state.preview,
	        unsupported = _state.unsupported;
	
	
	    if (unsupported) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_CssBaseline2.default, null),
	        _react2.default.createElement(_unsupported2.default, null)
	      );
	    }
	
	    if (this.props.location.pathname.includes('/videos/')) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_CssBaseline2.default, null),
	        children()
	      );
	    }
	
	    return _react2.default.createElement(
	      _styles.MuiThemeProvider,
	      { theme: _default.defaultTheme },
	      _react2.default.createElement(
	        'div',
	        null,
	        data && _react2.default.createElement(
	          _reactHelmet2.default,
	          {
	            title: data.meta.siteMetadata.title,
	            meta: [{
	              name: 'description',
	              content: data.meta.siteMetadata.description
	            }, {
	              name: 'keywords',
	              content: data.meta.siteMetadata.keywords
	            }]
	          },
	          _react2.default.createElement('html', { className: classes.root, lang: 'en', dir: 'ltr' })
	        ),
	        _react2.default.createElement(_header2.default, { open: open, toggle: this.toggle, preview: preview }),
	        _react2.default.createElement(_nav2.default, { open: open, toggle: this.toggle }),
	        _react2.default.createElement(_CssBaseline2.default, null),
	        children()
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Layout);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var styles = function styles(theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      fontSize: '80%'
	    }, _root[theme.breakpoints.up('sm')] = {
	      fontSize: '100%'
	    }, _root)
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var identity = {
	  logo: {
	    height: 40,
	    width: 100,
	    backgroundPosition: 'center center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'contain'
	  },
	  develop: {
	    navText: '#A2C3B7',
	    // backgroundGradient: 'linear-gradient(110deg, #64CDB4 0%, #53ABAF 55%, #4FA0AA 56%, #313C5E 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #41495e, #4b677c, #578796, #6ca7a8, #8fc7b5)',
	    from: '#41495e',
	    to: '#8fc7b5',
	    offset: '#ffffff'
	  },
	  devops: {
	    navText: '#C45A5E',
	    // backgroundGradient: 'linear-gradient(110deg, #FDBCDD 0%, #E24E74 55%, #DA3F68 56%, #D60424 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #ea3b4c, #e3475b, #db5268, #d15c73, #c6667c)',
	    from: '#ea3b4c',
	    to: '#c6667c',
	    offset: '#ffffff'
	  },
	  dynamics_365: {
	    navText: '#7760E3',
	    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #3e2772, #4f3291, #613eb1, #734ad3, #8656f5)',
	    from: '#3e2772',
	    to: '#8656f5',
	    offset: '#ffffff'
	  },
	  datascience: {
	    navText: '#38CCF1',
	    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
	    backgroundGradient: 'linear-gradient(to right top, #1659cb, #007ce0, #009beb, #00b8f0, #4ed4f2)',
	    from: '#7FDFF7',
	    to: '#145DCD',
	    offset: '#ffffff'
	  },
	  taas: {
	    navText: '#C4BE5A'
	  },
	  fixed: {
	    navText: '#E38E60'
	  },
	
	  studies: {
	    backgroundGradient:
	    // ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
	    offset: '#ffffff'
	  },
	  blog: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  careers: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  about: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  },
	  contact: {
	    backgroundGradient: ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
	    offset: '#ffffff'
	  }
	};
	
	exports.default = identity;
	module.exports = exports['default'];

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _identity = __webpack_require__(140);
	
	Object.defineProperty(exports, 'identity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_identity).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styles = __webpack_require__(11);
	
	var _colors = __webpack_require__(351);
	
	var _brand = __webpack_require__(657);
	
	var theme = (0, _styles.createMuiTheme)({
	  brand: _brand.identity,
	  typography: {
	    htmlFontSize: 10,
	    fontFamily: "'futura-pt',sans-serif;",
	    fontWeightLight: 300,
	    fontWeightRegular: 100,
	    fontWeightMedium: 500
	  },
	  palette: {
	    success: _colors.lightGreen[500],
	    soft: _colors.grey[400],
	    softer: _colors.grey[200],
	    grey: _colors.grey
	  }
	});
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _default = __webpack_require__(658);
	
	Object.defineProperty(exports, 'defaultTheme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_default).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-83c9ad088bff6c5515ed.js